import {
  isPlainObject as _isPlainObject,
  includes as _includes,
  forOwn as _forOwn,
  kebabCase as _kebabCase,
} from 'lodash';

const isReadOnly = (attribute, readOnly) => {
  return readOnly.indexOf(attribute) !== -1;
};

const isRelationship = (attribute) => {
  return _isPlainObject(attribute) && _includes(['hasOne', 'hasMany'], attribute.jsonApi);
};

const serializeHasMany = (relationships, type) => {
  return {
    data: relationships.map((item) => {
      return {
        id: item.id,
        type: type || item.type,
      };
    }),
  };
};

const serializeHasOne = (relationship, type) => {
  if (relationship === null) {
    return {
      data: null,
    };
  }
  return {
    data: {
      id: relationship.id,
      type: type || relationship.type,
    },
  };
};

const serializeRelationship = (
  relationshipName,
  relationship,
  relationshipType,
  serializeRelationships,
) => {
  const serializedRelationshipName = _kebabCase(relationshipName);
  if (relationshipType.jsonApi === 'hasMany' && relationship !== undefined) {
    serializeRelationships[serializedRelationshipName] = serializeHasMany(
      relationship,
      relationshipType.type,
    );
  }

  if (relationshipType.jsonApi === 'hasOne' && relationship !== undefined) {
    serializeRelationships[serializedRelationshipName] = serializeHasOne(
      relationship,
      relationshipType.type,
    );
  }
};

// Mostly copied from devour, but adding in kebab-case key behavior
const serialize = (jsonApi, modelName, item) => {
  const model = jsonApi.modelFor(modelName);
  const options = model.options || {};
  const readOnly = options.readOnly || [];
  const typeName = options.type || jsonApi.pluralize(modelName);
  const serializedAttributes = {};
  const serializedRelationships = {};
  const serializedResource = {};

  _forOwn(model.attributes, (value, key) => {
    if (isReadOnly(key, readOnly)) {
      return;
    }

    if (isRelationship(value)) {
      serializeRelationship(key, item[key], value, serializedRelationships);
    } else if (item[key] !== undefined) {
      const serializedKey = _kebabCase(key);

      serializedAttributes[serializedKey] = item[key];
    }
  });

  serializedResource.type = typeName;

  if (Object.keys(serializedAttributes).length > 0) {
    serializedResource.attributes = serializedAttributes;
  }

  if (Object.keys(serializedRelationships).length > 0) {
    serializedResource.relationships = serializedRelationships;
  }

  if (item.id) {
    serializedResource.id = item.id;
  }

  if (item.meta) {
    serializedResource.meta = item.meta;
  }

  if (item.links) {
    serializedResource.links = item.links;
  }

  return serializedResource;
};

export default serialize;
